// extracted by mini-css-extract-plugin
export var active = "_cd-2";
export var recordingDot = "_cd-1";
export var recordingIndicator = "_cd-0";